import { Group, Stack } from "@mantine/core";
import { useNavigate, useParams, useRouteLoaderData } from "react-router-dom";
import TeamUsers from "./TeamUsers";
import TeamSettings from "./TeamSettings";
import CommunityDropdown from "../resellers/CommunityDropdown";
import CreateUser from "../../resellers/createUser/CreateUserButton";

const TeamPage = () => {
  const team = useRouteLoaderData("team");
  const { tab } = useParams();
  const navigate = useNavigate();
  return (
    <Stack gap={0} pr={48} pt={32}>
      <Group justify="space-between">
        <CommunityDropdown
          getClickLink={(id) => `/settings/teams/${id}`}
          getDeletedLink={(id) => `/settings/teams/`}
          type="teams"
        />

        <CreateUser parentUrl={`/settings/teams/${team.id}/`} />
      </Group>

      {tab === "users" ? <TeamUsers /> : <TeamSettings />}
    </Stack>
  );
};

export default TeamPage;
